import React from "react";
import AppRoutes from "./routes";
import { LanguageProvider } from "./contexts/LanguageContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import { GlobalThemeStyle } from "./styles/GlobalThemeStyle";
import "./utils/configureSwal";

const layoutStyle = {
  width: "100%", 
  height: "100%", 
  margin: 0, 
  padding: 0, 
  boxSizing: "border-box", 
};


function App() {
  return (
    <ThemeProvider>
      <GlobalThemeStyle />
      <LanguageProvider>
        <div style={layoutStyle}>
          <AppRoutes />
        </div>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
